// @ts-nocheck
// fetching perfume recommendation
async function AskAI(question) {
  console.log("******** Calling AI ********************");
  const key =
    "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";

  const APIBody = {
    model: "gpt-4o",
    messages: [{ role: "user", content: question }],
    temperature: 0.2,
    max_tokens: 600,
  };
  let suggestion = "";

  await fetch("https://api.openai.com/v1/chat/completions", {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      Authorization: "Bearer " + key,
    },
    body: JSON.stringify(APIBody),
  })
    .then((response) => response.json())
    .then((data) => {
      console.log("Data: " + data);
      suggestion = data.choices[0].message.content;
      console.log("Response:" + suggestion);
    })
    .catch((error) => console.log("error", error));
  return suggestion;
}
